const features = [
  {
    icon: "ri-lock-2-line",
    title: "End-to-End Encryption",
    desc: "All data transmitted through our VPN is protected with AES-256 encryption — the same standard used by governments and financial institutions.",
    accent: "emerald",
    large: false,
  },
  {
    icon: "ri-eye-off-line",
    title: "Zero-Log Architecture",
    desc: "We never store, track, or sell your browsing data. Your online activity is yours alone.",
    accent: "teal",
    large: false,
  },
  {
    icon: "ri-global-line",
    title: "Global Server Coverage",
    desc: "Access content from anywhere with our worldwide network of high-speed servers spanning 50+ countries.",
    accent: "emerald",
    large: false,
  },
  {
    icon: "ri-delete-bin-6-line",
    title: "Deep Junk Removal",
    desc: "Our Cleaner app intelligently identifies and removes temporary files, app caches, duplicate photos, and residual data that silently consume your storage.",
    accent: "teal",
    large: true,
  },
  {
    icon: "ri-battery-charge-line",
    title: "Battery Optimization",
    desc: "Identify battery-draining apps and background processes to extend your iPhone&apos;s battery life significantly.",
    accent: "emerald",
    large: false,
  },
  {
    icon: "ri-cpu-line",
    title: "Memory Management",
    desc: "Free up RAM instantly and keep your device running smoothly even with multiple apps open.",
    accent: "teal",
    large: false,
  },
];

const accentMap: Record<string, string> = {
  emerald: "bg-emerald-50 text-emerald-600 border-emerald-100",
  teal: "bg-teal-50 text-teal-600 border-teal-100",
};

const iconBgMap: Record<string, string> = {
  emerald: "bg-emerald-100 text-emerald-600",
  teal: "bg-teal-100 text-teal-600",
};

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-[#F7F6F2] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold tracking-[0.2em] text-gray-400 uppercase mb-4">/ Features</p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Why Choose Our Applications
          </h2>
          <p className="text-gray-500 text-base md:text-lg mt-4 max-w-xl mx-auto leading-relaxed">
            Every feature is thoughtfully designed to deliver real value — not just checkboxes on a spec sheet.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className={`bg-white rounded-2xl p-7 border ${accentMap[f.accent].split(" ")[2]} hover:border-gray-200 transition-all duration-300 ${
                f.large ? "lg:col-span-1" : ""
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl mb-5 ${iconBgMap[f.accent]}`}>
                <i className={`${f.icon} text-lg`} />
              </div>
              <h3 className="text-gray-900 font-bold text-base mb-3">{f.title}</h3>
              <p
                className="text-gray-500 text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: f.desc }}
              />
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-12 rounded-3xl overflow-hidden relative h-56 md:h-72">
          <img
            src="https://public.readdy.ai/ai/img_res/252a4882145c85316d2ba098e2ce2aee.jpg"
            alt="Technology background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 to-gray-900/40 flex items-center px-10 md:px-16">
            <div>
              <p className="text-white/60 text-xs tracking-widest uppercase mb-3">Trusted Technology</p>
              <h3 className="text-white text-2xl md:text-3xl font-extrabold max-w-md leading-snug">
                Enterprise-Grade Security in Your Pocket
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
